import { createStyles, Theme } from '@material-ui/core';

const styles = ({ colors, spacing }: Theme) => createStyles({
  title: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    padding: `${spacing(4)}px 0`,
    paddingBottom: `${spacing(1)}px`,
    borderBottom: `2px solid ${colors.layout.divider300}`,
    marginBottom: `${spacing(3)}px`,
  },
  rowDistance: {
    marginBottom: `${colors.pageElements.serviceCard.rowsDistance}px`,
  },
  mb2: {
    marginBottom: `${spacing(2)}px`,
  },
});

export default styles;
